
export class Contact {
    firstName: string;
    lastName: string;
    email: string;
    company: string;
    department: string;

    constructor(data) {
        Object.assign(this, data);
    }
}